import { getAuthData } from "../features/auth/session.js";
// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as React from "react";
import { redeemPromocode } from "../api/promocode.jsx";
import * as jsxRuntime from "react/jsx-runtime";
import { IconChevronLeft } from "../components/icons.jsx";
import { IconSpeakerphone } from "../components/icons.jsx";
import { IconChevronRight } from "../components/icons.jsx";
export const Cy = "_page_284zb_1";
export const My = "_header_284zb_2";
export const Ay = "_back_284zb_3";
export const Ey = "_title_284zb_5";
export const Dy = "_subtitle_284zb_6";
export const zy = "_form_284zb_7";
export const Oy = "_hint_284zb_11";
export const ky = "_apply_284zb_12";
export const Ry = "_error_284zb_15";
export const By = "_success_284zb_15";
export const Uy = "_channel_284zb_19";
export const Hy = "_channelIcon_284zb_20";
export const Ly = "_channelText_284zb_22";
export const qy = "_channelArrow_284zb_25";
export const Gy = "_srOnly_284zb_26";
export const Ct = {
  page: Cy,
  header: My,
  back: Ay,
  title: Ey,
  subtitle: Dy,
  form: zy,
  hint: Oy,
  apply: ky,
  error: Ry,
  success: By,
  channel: Uy,
  channelIcon: Hy,
  channelText: Ly,
  channelArrow: qy,
  srOnly: Gy
};
export const Yy = {
  invalid_code: "Введите промокод.",
  not_found: "Промокод не найден. Проверьте написание.",
  exhausted: "Активации этого промокода закончились.",
  already_used: "Вы уже активировали этот промокод.",
  reward_error: "Не удалось выдать награду. Попробуйте позже."
};
export const xo = u => u.toLocaleString("ru-RU");
export function PromocodePage({
  onBack: u,
  onRedeemed: o
}) {
  const [m, r] = React.useState(""),
    [g, j] = React.useState(!1),
    [B, U] = React.useState(""),
    [N, y] = React.useState(null),
    X = window.Telegram?.WebApp?.BackButton;
  React.useEffect(() => {
    if (window.scrollTo(0, 0), !!X) return X.show(), X.onClick(u), () => {
      X.offClick(u), X.hide();
    };
  }, [X, u]);
  async function M(R) {
    if (R.preventDefault(), g) return;
    const H = m.trim();
    if (!H) {
      U("Введите промокод.");
      return;
    }
    if (!/^[A-Za-z0-9_-]{1,128}$/.test(H)) {
      U("Используйте латиницу, цифры, дефис или подчёркивание.");
      return;
    }
    const Y = getAuthData();
    if (!Y) {
      U("Откройте промокод внутри Telegram.");
      return;
    }
    j(!0), U(""), y(null);
    try {
      const P = await redeemPromocode(Y, H);
      if (P.status !== "ok") {
        U(Yy[P.status] || "Не удалось активировать промокод.");
        return;
      }
      y(P.rewards), r(""), o(P.rewards);
    } catch (P) {
      U(P instanceof Error && !/Failed to fetch|NetworkError/i.test(P.message) ? P.message : "Нет соединения. Попробуйте ещё раз.");
    } finally {
      j(!1);
    }
  }
  return jsxRuntime.jsxs("section", {
    className: Ct.page,
    "aria-labelledby": "promo-title",
    children: [jsxRuntime.jsxs("header", {
      className: Ct.header,
      children: [jsxRuntime.jsx("button", {
        type: "button",
        className: `${Ct.back} mc-icon-button`,
        onClick: u,
        "aria-label": "Назад к профилю",
        children: jsxRuntime.jsx(IconChevronLeft, {
          "aria-hidden": "true"
        })
      }), jsxRuntime.jsx("h1", {
        id: "promo-title",
        className: Ct.title,
        children: "Промокод"
      })]
    }), jsxRuntime.jsx("p", {
      className: Ct.subtitle,
      children: "Код из анонсов и ивентов — награды сразу"
    }), jsxRuntime.jsxs("form", {
      className: Ct.form,
      onSubmit: R => {
        M(R);
      },
      children: [jsxRuntime.jsx("label", {
        htmlFor: "mc-promocode",
        className: Ct.srOnly,
        children: "Промокод"
      }), jsxRuntime.jsx("input", {
        id: "mc-promocode",
        type: "text",
        autoComplete: "off",
        autoCapitalize: "none",
        spellCheck: !1,
        maxLength: 128,
        placeholder: "НАПРИМЕР, METACARD",
        value: m,
        onChange: R => {
          r(R.target.value), U(""), y(null);
        },
        "aria-describedby": "mc-promocode-hint"
      }), jsxRuntime.jsx("p", {
        id: "mc-promocode-hint",
        className: Ct.hint,
        children: "латиница и цифры"
      }), jsxRuntime.jsx("button", {
        type: "submit",
        className: Ct.apply,
        disabled: g || !m.trim(),
        children: g ? "ПРОВЕРЯЕМ…" : "ПРИМЕНИТЬ"
      })]
    }), B && jsxRuntime.jsx("p", {
      className: Ct.error,
      role: "alert",
      children: B
    }), N && jsxRuntime.jsxs("div", {
      className: Ct.success,
      role: "status",
      children: [jsxRuntime.jsx("strong", {
        children: "Промокод активирован!"
      }), jsxRuntime.jsx("span", {
        children: [N.crystals > 0 && `💎 ${xo(N.crystals)} кристаллов`, N.spins > 0 && `🎴 ${xo(N.spins)} круток`, N.metacoins > 0 && `🪙 ${xo(N.metacoins)} MetaCoin`].filter(Boolean).join(" · ") || "Награда начислена"
      })]
    }), jsxRuntime.jsxs("a", {
      className: Ct.channel,
      href: "https://t.me/MetaCardOFF",
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: R => {
        const H = window.Telegram?.WebApp;
        H?.openTelegramLink && (R.preventDefault(), H.openTelegramLink("https://t.me/MetaCardOFF"));
      },
      children: [jsxRuntime.jsx("span", {
        className: Ct.channelIcon,
        children: jsxRuntime.jsx(IconSpeakerphone, {
          "aria-hidden": "true"
        })
      }), jsxRuntime.jsxs("span", {
        className: Ct.channelText,
        children: [jsxRuntime.jsx("strong", {
          children: "КАНАЛ ИГРЫ · @MetaCardOFF"
        }), jsxRuntime.jsx("small", {
          children: "промокоды выходят там первыми, вместе с анонсами ивентов"
        })]
      }), jsxRuntime.jsx(IconChevronRight, {
        className: Ct.channelArrow,
        "aria-hidden": "true"
      })]
    })]
  });
}
